import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';

import { Invoice } from '../models/invoice';

@Component({
  selector: 'app-invoice-status-icon',
  templateUrl: './invoice-status-icon.component.html',
  styleUrls: ['./invoice-status-icon.component.scss'],
})
export class InvoiceStatusIconComponent implements OnInit {
  
  @Input() invoice?: Invoice;
  //@ViewChild('childComponentTemplate') childComponentTemplate: TemplateRef<any>;
  @ViewChild('childComponentTemplate', { static: true }) childComponentTemplate: TemplateRef<any>;

  constructor() { }

  ngOnInit() {}

}
